import { render, staticRenderFns } from "./RequestKits.vue?vue&type=template&id=4066e53e&scoped=true"
import script from "./RequestKits.vue?vue&type=script&lang=js"
export * from "./RequestKits.vue?vue&type=script&lang=js"
import style0 from "./RequestKits.vue?vue&type=style&index=0&id=4066e53e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4066e53e",
  null
  
)

export default component.exports